import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { newsList } from '@/mocks/news';
import { worksList } from '@/mocks/works';

interface Slide {
  id: string;
  title: string;
  summary: string;
  cover: string;
  tag: string;
  link: string;
}

const slides: Slide[] = [
  {
    id: newsList[0].id,
    title: newsList[0].title,
    summary: newsList[0].summary,
    cover: newsList[0].cover,
    tag: '热点新闻',
    link: `/detail/${newsList[0].id}`,
  },
  {
    id: worksList[0].id,
    title: `新作上线：《${worksList[0].title}》`,
    summary: worksList[0].intro,
    cover: worksList[0].cover,
    tag: '影视作品',
    link: `/detail/${worksList[0].id}`,
  },
  {
    id: newsList[4].id,
    title: newsList[4].title,
    summary: newsList[4].summary,
    cover: newsList[4].cover,
    tag: '独家专访',
    link: `/detail/${newsList[4].id}`,
  },
];

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 5500);
    return () => clearInterval(timer);
  }, []);

  const current = slides[index];

  return (
    <div className="relative w-full h-[360px] md:h-[480px] rounded-lg overflow-hidden">
      {slides.map((slide, i) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ${i === index ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        >
          <img
            src={slide.cover}
            alt={slide.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-primary-950/85 via-primary-950/30 to-primary-950/10"></div>
          <div className="absolute bottom-0 left-0 right-0 p-5 md:p-10">
            <span className="inline-block bg-accent-500 text-background-50 text-xs font-label px-3 py-1 rounded-full mb-3 whitespace-nowrap">
              {slide.tag}
            </span>
            <Link to={slide.link} className="block cursor-pointer">
              <h2 className="text-background-50 font-heading text-xl md:text-3xl font-bold mb-2 leading-snug max-w-2xl">
                {slide.title}
              </h2>
            </Link>
            <p className="text-background-100/90 text-sm md:text-base max-w-xl hidden sm:block">
              {slide.summary}
            </p>
          </div>
        </div>
      ))}

      <button
        type="button"
        onClick={() => setIndex((prev) => (prev - 1 + slides.length) % slides.length)}
        className="cursor-pointer absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/30 hover:bg-background-50/50 text-background-50 transition-colors"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
      </button>
      <button
        type="button"
        onClick={() => setIndex((prev) => (prev + 1) % slides.length)}
        className="cursor-pointer absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/30 hover:bg-background-50/50 text-background-50 transition-colors"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>

      <div className="absolute bottom-4 right-4 md:right-10 flex gap-2">
        {slides.map((slide, i) => (
          <button
            key={slide.id}
            type="button"
            onClick={() => setIndex(i)}
            aria-label={`切换到第${i + 1}张`}
            className={`cursor-pointer w-2 h-2 rounded-full transition-all ${i === index ? 'bg-accent-500 w-6' : 'bg-background-50/60'}`}
          ></button>
        ))}
      </div>
    </div>
  );
}